<div class="ptl-onboarding"
    [ngClass]="[setFontIntelDisplayOne ? 'intelOne-display':'latin-bold', ( ptl12xe || ptlgaming )? 'white-font' : 'black-font']">
    <div class="onboarding-welcome-section">
        <div class="welcome-section-heading" [style.fontWeight]="isEnglish?'500':'650'" [innerHtml]="ptlOnboardingText?.tr_welcome"></div>
        <div class="welcome-section-subheading" [innerHtml]="ptlOnboardingText?.tr_start_text"></div>
    </div>
    <div class="onboarding-nav-tabs">
        <div class="nav-tab" (click)="routeToPage(navtab)"
            *ngFor="let navtab of ptlOnboardingText.tr_tabs; let i = index "  [ngClass]="(promoLength === 0 && i==2) ? 'hide-promos':''">
            <div class="nav-tab-content">
                <div class="nav-tab-text" [class.rtl-align]="isRTL" >
                    <div class="nav-tab-text-heading" [style.fontWeight]="isEnglish?'500':'650'"S [innerHtml]="navtab.tr_tab_heading"></div>
                    <div class="nav-tab-text-subheading" [ngClass]="(ptl12xe || ptlgaming) ? 'ptl-12xe-greyish-font' : 'ptl-greyish-font'" [innerHtml]="navtab.tr_tab_subheading"></div>
                </div>
                <div class="nav-tab-icon" [class.rtl-nav-icon]="isRTL">
                    <img src="{{ptlArrow}}" alt="nav_arrow">
                    
                </div>
            </div>
            <div class="nav-tab-separator" >
                <hr class="line-separator" [ngClass]="ptl12xe ? 'ptl-12xe-separator' : ptlgaming ? 'ptl-gaming-separator':'ptl-separator'"
                    *ngIf="i < ptlOnboardingText.tr_tabs.length - 1" />
            </div>
        </div>
    </div>
    <div class="ptl-onboarding-footer">
        <img class="ptl-intel-logo" *ngIf="!(ptl12xe || ptlgaming)" [src]="ptlOnboardingText?.ptl_intel_logo" alt="intel_logo">
        <img class="ptl-intel-logo" *ngIf="(ptl12xe || ptlgaming)" [src]="ptlOnboardingText?.ptl_12xe_intel_logo" alt="intel_logo">
    </div>
</div>